export default "__VITE_ASSET__85753603__"